
export function buildBaseUrl(baseArr) {
    const protocol = baseArr.https ? 'https://' : '';
    return `${protocol}${baseArr.basePath}/${baseArr.path}/${baseArr.collection}?`;
}

export function isMutationFulfilled(mutationResult){
    return mutationResult.status === 'fulfilled'
}
